/**
 * Easing transtion values
 * @param string type Type of easing. See switch to get easings type
 * @param duration float Duration of the easing
 * @param start float Value to start easing
 * @param end float Value to end easing
 * @param callback function Callback function for when easing ends
 *
 */

export default class Easing {
  constructor (args) {
    this.update = this.update.bind(this)
    this.onDesactivate = this.onDesactivate.bind(this)
    this.setEnd = this.setEnd.bind(this)

    this.type = args.type !== void 0 ? args.type : false
    this.duration = args.duration !== void 0 ? args.duration : false
    this.start = args.start !== void 0 ? args.start : false
    this.end = args.end !== void 0 ? args.end : false
    this.delay = args.delay !== void 0 ? args.delay : 0
    this.callback = args.callback !== void 0 ? args.callback : false

    if (this.duration === false) { console.warn('Easing needs duration argument'); return }
    if (this.start === false) { console.warn('Easing needs start argument'); return }
    if (this.end === false) { console.warn('Easing needs end argument'); return }

    this.time = 0
    this.value = this.start
    this.isActive = this.delay === 0
    this.t = 0
    this.setEnd(this.end)

    if (!this.isActive) {
      setTimeout(() => {
        this.isActive = true
      }, this.delay)
    }
  }

  update (delta) {
    if (this.isActive) {
      this.time += delta
    }

    let t = this.time / this.duration
    let Limit = t

    this.value = 0

    switch (this.type) {
      case 'linear':
        t = Limit
        break
      case 'easeInQuad':
        t = t * t
        break
      case 'easeOutQuad':
        t = t * (2 - t)
        break
      case 'easeInOutQuad':
        t = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
        break
      case 'easeInCubic':
        t = t * t * t
        break
      case 'easeOutCubic':
        t = (--t) * t * t + 1
        break
      case 'easeInOutCubic':
        t = t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
        break
      case 'easeInQuart':
        t = t * t * t * t
        break
      case 'easeOutQuart':
        t = 1 - (--t) * t * t * t
        break
      case 'easeInOutQuart':
        t = t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t
        break
      case 'easeInQuint':
        t = t * t * t * t * t
        break
      case 'easeOutQuint':
        t = 1 + (--t) * t * t * t * t
        break
      case 'easeInOutQuint':
        t = (t < 0.5) ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
        break
      default:
        t = Limit
    }

    this.t = t
    this.value = this.start + t * this.delta
    if (Limit >= 1 && this.isActive) {
      requestAnimationFrame(this.onDesactivate)
    }

    return this.value
  }

  setEnd (value) {
    this.end = value
    this.delta = this.end - this.start
  }

  onDesactivate () {
    this.isActive = false
    this.value = this.end

    if (this.callback) {
      this.callback()
    }
  }
}
